const CORP_KEY_STORAGE_KEY = 'corpKey'
const SCOPE_STORAGE_KEY = 'scope'
const DEFAULT_CORP_KEY = 'lechun'
const DEFAULT_SCOPE = 'lechun'

function getQueryParam(key) {
  if (typeof window === 'undefined') {
    return ''
  }
  const searchParams = new URLSearchParams(window.location.search || '')
  const searchValue = searchParams.get(key)
  if (searchValue) {
    return searchValue
  }
  const hash = window.location.hash || ''
  const queryStart = hash.indexOf('?')
  if (queryStart === -1) {
    return ''
  }
  const hashSearch = hash.substring(queryStart + 1)
  const hashParams = new URLSearchParams(hashSearch)
  return hashParams.get(key) || ''
}

function getQueryCorpKey() {
  return getQueryParam('corpKey')
}

function getQueryScope() {
  return getQueryParam('scope')
}

function getEnvCorpKey() {
  return process.env.VUE_APP_CORP_KEY || ''
}

function getEnvScope() {
  return process.env.VUE_APP_SCOPE || ''
}

function getStoredValue(key) {
  if (typeof window === 'undefined' || !window.localStorage) {
    return ''
  }
  return window.localStorage.getItem(key) || ''
}

function setStoredValue(key, value) {
  if (typeof window === 'undefined' || !window.localStorage || !value) {
    return
  }
  window.localStorage.setItem(key, value)
}

function hasOwnParam(params, key) {
  return Object.prototype.hasOwnProperty.call(params || {}, key)
}

export function getCorpKeyFromContext() {
  const queryCorpKey = getQueryCorpKey()
  if (queryCorpKey) {
    setStoredValue(CORP_KEY_STORAGE_KEY, queryCorpKey)
    return queryCorpKey
  }
  return getStoredValue(CORP_KEY_STORAGE_KEY) || getEnvCorpKey() || DEFAULT_CORP_KEY
}

export function getScopeFromContext() {
  const queryScope = getQueryScope()
  if (queryScope) {
    setStoredValue(SCOPE_STORAGE_KEY, queryScope)
    return queryScope
  }
  return getStoredValue(SCOPE_STORAGE_KEY) || getEnvScope() || DEFAULT_SCOPE
}

export function shouldAppendCorpKey(url) {
  if (!url) {
    return false
  }
  return [
    'lechun-cms/scrmCalendar/getQwUser',
    'lechun-cms/moment/',
    'lechun-cms/qiyeweixin/',
    'lechun-cms/qiWeiPerformanceMember/',
    'lechun-cms/user/getQiWeiUserInfoList',
    'lechun-bi/generateScene/getQw'
  ].some(item => url.indexOf(item) > -1)
}

export function shouldAppendScope(url) {
  if (!url) {
    return false
  }
  return [
    'lechun-cms/scene/getScenePageList',
    'lechun-cms/scene/getUserGroupDetail',
    'lechun-cms/scene/getUserCount',
    'lechun-cms/scene/saveUserGroup',
    'lechun-cms/scene/getSceneEntity',
    'lechun-cms/scene/saveSceneEntity',
    'lechun-cms/scene/changeStatus',
    'lechun-cms/scene/deleteScene',
    'lechun-cms/scene/copyUserGroup',
    'lechun-cms/scene/saveSceneName',
    'lechun-cms/scene/getSceneOption',
    'lechun-cms/sceneRouteGroup/',
    'lechun-cms/scrmRoute/getRoutePageList',
    'lechun-cms/scrmRoute/saveRoute',
    'lechun-cms/scrmRoute/changeRouteStatus',
    'lechun-cms/scrmRoute/deleteRoute',
    'lechun-cms/scrmRoute/execRouteLik',
    'lechun-cms/scrmRoute/copyRoute',
    'lechun-cms/scrmRoute/getRouteLinks',
    'lechun-cms/scrmRoute/saveRouteLinks',
    'lechun-cms/scrmRoute/deployRoute',
    'lechun-cms/event/getEventCondtion',
    'lechun-cms/event/getEventList',
    'lechun-cms/event/saveEvent',
    'lechun-cms/event/getEventGroupList',
    'lechun-cms/event/saveEventGroup',
    'lechun-cms/event/getEvent',
    'lechun-cms/event/deleteEvent',
    'lechun-cms/event/changeEventStatus',
    'lechun-cms/scrmproperty/getPagePropertyList',
    'lechun-cms/scrmproperty/saveProperty',
    'lechun-cms/scrmproperty/getProperty',
    'lechun-cms/scrmproperty/deleteProperty',
    'lechun-cms/scrmproperty/getPropertyList',
    'lechun-cms/scrmproperty/getEventPropertyList',
    'lechun-cms/scrmproperty/saveEventProperty',
    'lechun-cms/scrmproperty/getEventProperty',
    'lechun-cms/scrmproperty/deleteEventProperty'
  ].some(item => url.indexOf(item) > -1)
}

export function appendCorpKeyIfNeeded(url, params = {}) {
  const needsCorpKey = shouldAppendCorpKey(url)
  const needsScope = shouldAppendScope(url)
  if (!needsCorpKey && !needsScope) {
    return params || {}
  }
  if (typeof FormData !== 'undefined' && params instanceof FormData) {
    if (needsCorpKey && !params.has('corpKey')) {
      params.append('corpKey', getCorpKeyFromContext())
    }
    if (needsScope && !params.has('scope')) {
      params.append('scope', getScopeFromContext())
    }
    return params
  }
  const nextParams = {
    ...(params || {})
  }
  if (needsCorpKey && !hasOwnParam(nextParams, 'corpKey')) {
    nextParams.corpKey = getCorpKeyFromContext()
  }
  if (needsScope && !hasOwnParam(nextParams, 'scope')) {
    nextParams.scope = getScopeFromContext()
  }
  return nextParams
}
